var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 117,
    viewBox: "0 0 135 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0312 17.4995C36.1375 20.1808 32.8625 23.5308 28.9313 27.5558C17.1438 39.612 11.25 45.637 11.25 53.1245C11.25 60.612 17.1438 66.637 28.9313 78.6995L68.9313 119.618C70.4479 121.16 72.0542 122.535 73.75 123.743",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 96.3442C130 114.938 114.456 130 95.275 130H39.725C23.35 130 15.1687 130 10.0875 125.069C4.99999 120.144 5 112.213 5 96.3442C5 92.5505 5 89.2067 5.06875 86.2505",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.625 101.875H95.5688M130 42.5H61.25M130 73.75H61.25M130 39.725C130 23.35 130 15.1687 124.969 10.0875C119.931 5 111.831 5 95.625 5C79.4188 5 71.3125 5 66.2813 10.0875C61.25 15.1687 61.25 23.3563 61.25 39.725V95.275C61.25 114.456 76.6375 130 95.625 130C114.613 130 130 114.456 130 95.275V39.725Z",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon5);
export default __webpack_public_path__ + "static/media/about-icon5.6e9c888fbfbb4a47bce795cd1d2208aa.svg";
export { ForwardRef as ReactComponent };